import { renderInlineFormat } from './InlineFormat'

/**
 * Thin wrapper over the shared inline formatter (Stage 2.2).
 *
 * Previously handled only `**bold**` and `[label](doc:section-id)`; it now also
 * renders italic, strikethrough, inline code and web links, because all four
 * arrived as literal syntax in assistant copy before.
 *
 * It takes no citations: this is the demo/block path, where markers are not
 * present. Passing an empty list keeps segmentation a no-op rather than a
 * silent behaviour difference from the phase1 wrapper.
 *
 * @param {{ text: string }} props
 */
export default function FormattedAgentText({ text }) {
  return renderInlineFormat(String(text ?? ''), [], 'fmt')
}
